module.exports = __webpack_public_path__ + "img/pdu.87256732.svg";